import { useState } from "react";
import PageShell from "../components/common/PageShell";
import useChickenHistory from "../hooks/useChickenHistory";
import { inr, dtShort } from "../utils/format";

// GET /chicken/history se real bet history
const TAG = { cashed: "w", burnt: "l", refunded: "n", active: "n" };
const LABEL = { cashed: "Won", burnt: "Lost", refunded: "Refunded", active: "Active" };

export default function MyBets() {
  const [f, setF] = useState("all");
  const { rows, loading, error, reload } = useChickenHistory();

  const settled = rows.filter((b) => b.outcome === "cashed" || b.outcome === "burnt");
  const shown = rows.filter((b) => f === "all" || (f === "won" ? b.outcome === "cashed" : b.outcome === "burnt"));
  const staked = settled.reduce((s, b) => s + b.bet, 0);
  const won = settled.reduce((s, b) => s + b.win, 0);
  const net = won - staked;

  return (
    <PageShell title="Bet History">
      <section className="pg-stats">
        <div className="pg-stat"><span className="pg-muted">Staked</span><b>{inr(staked)}</b></div>
        <div className="pg-stat"><span className="pg-muted">Won</span><b className="pg-win">{inr(won)}</b></div>
        <div className="pg-stat">
          <span className="pg-muted">Net</span>
          <b className={net >= 0 ? "pg-win" : "pg-lose"}>{net >= 0 ? "+" : "-"}{inr(Math.abs(net))}</b>
        </div>
      </section>
      <p className="pg-muted">Showing {shown.length} of {rows.length} rounds</p>

      <div className="pg-tabs">
        {["all", "won", "lost"].map((t) => (
          <button key={t} className={`pg-tab ${f === t ? "on" : ""}`} onClick={() => setF(t)}>
            {t[0].toUpperCase() + t.slice(1)}
          </button>
        ))}
      </div>

      <section className="pg-card">
        {loading ? (
          <p className="pg-empty">Loading...</p>
        ) : error ? (
          <p className="pg-empty">{error} <button className="pg-tab" onClick={reload}>Retry</button></p>
        ) : shown.length === 0 ? (
          <p className="pg-empty">No bets here yet.</p>
        ) : (
          <table className="pg-table">
            <thead>
              <tr><th>Time</th><th>Round</th><th>Difficulty</th><th>Bet</th><th>Multiplier</th><th>Win</th><th>Result</th></tr>
            </thead>
            <tbody>
              {shown.map((b) => (
                <tr key={b.id}>
                  <td data-l="Time">{dtShort(b.createdAt)}</td>
                  <td data-l="Round">{b.id.slice(-8)}</td>
                  <td data-l="Difficulty"><span className={`pg-diff ${b.difficulty.toLowerCase()}`}>{b.difficulty}</span></td>
                  <td data-l="Bet">{inr(b.bet)}</td>
                  <td data-l="Multiplier"><span className={`pg-mult ${b.outcome === "cashed" ? "won" : ""}`}>x{b.outcome === "cashed" ? b.multiplier.toFixed(2) : 0}</span></td>
                  <td data-l="Win">{b.outcome === "cashed" ? <><i className="pg-coin">₹</i>{b.win.toLocaleString("en-IN")}</> : "–"}</td>
                  <td data-l="Result">
                    <span className={`pg-tag ${TAG[b.outcome]}`}>
                      {b.outcome === "cashed" ? `+${inr(b.win - b.bet)}` : b.outcome === "burnt" ? `-${inr(b.bet)}` : LABEL[b.outcome]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </PageShell>
  );
}
